import React from 'react'

import Hero from 'components/shared/Hero'
import Image from 'components/shared/Image'
import Separator from 'components/shared/Separator'
import RichText from 'components/typo/RichText'
import Layout from 'components/shared/Layout'
import Parallax from 'components/shared/Parallax'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const UseCaseHero = ({
  introText,
  asideImage,
  divider,
  hero,
  className,
  ...rest
}) => {
  return (
    <div className={cx(css.UseCaseHero, { withIntro: introText })}>
      {hero && <Hero {...hero} smallAssets />}
      {asideImage && asideImage.media && (
        <Parallax distance={12}>
          {(ref) => (
            <div ref={ref} className={css.visualWrapper}>
              <Image format={null} className={css.heroVisual} {...asideImage} />
            </div>
          )}
        </Parallax>
      )}
      {introText && (
        <Layout type="maxWidth">
          <Layout type="wrapper">
            <Layout type="innerWrapper">
              <RichText
                type="Text"
                size="big"
                text={introText}
                className={css.introText}
              />
            </Layout>
            {divider && <Separator />}
          </Layout>
        </Layout>
      )}
    </div>
  )
}

UseCaseHero.defaultProps = {}

export default UseCaseHero
